<template>
  <transition-group name='fade'>
    <div @click="defaultMask" @touchmove.prevent class="mask" key="1" v-if="show"></div>
    <div class="switch-pop" key="2" v-show="show"  >
      <div class="switch-pop-title">
        开关控制
      </div>
      <div class="switch-pop-button">
        <el-button @click="btnOK">开启</el-button>
        <el-button @click="btnCancel">关闭</el-button>
      </div>
<!--      <el-form :inline="true">-->
<!--        <el-form-item style="text-align: center;">-->
<!--          <el-button @click="btnOK">开启</el-button>-->
<!--          <el-button @click="btnCancel">关闭</el-button>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
    </div>
  </transition-group>
</template>

<script>
  import {
    clientInfo,
    getAttributesClient,
    getCredentials,
  } from "../../untils/api/home";

  export default {
    name: 'switchSet',
    data() {
      return {
        show: false,
        deviceInfo: {},
        credentialsId: '',
        switchJson: {},
        openFlg: 3,
      }
    },
    mounted() {
      if (window.history && window.history.pushState) {
        window.addEventListener("popstate", this.defaultMask, false);
      }
    },

    destroyed() {
      window.removeEventListener("popstate", this.defaultMask, false);
    },

    methods: {
      btnOK() {
        this.switchJson = {};
        this.openFlg = 1;
        this.setSwitchJson();
        this.getCredentialsId();
        this.show = false;
      },

      btnCancel() {
        this.switchJson = {};
        this.openFlg = 0;
        this.setSwitchJson();
        this.getCredentialsId();
        this.show = false;
      },

      setSwitchJson() {
        this.switchJson.op_fl = this.openFlg;
        this.switchJson.op_t = 360;
        this.switchJson.h_op_t = 18;
        this.switchJson.m_op_t = 0;
        this.switchJson.sT = 1;
        this.switchJson.opVol = 14;
        this.switchJson.opDt = 30;
        this.switchJson.ver = 2;
        this.switchJson.time = Math.floor(Date.now() / 1000);
      },

      getCredentialsId() {
        //访问api获取设备信息
        getCredentials(this.deviceInfo.id).then(response => {
          this.credentialsId = response.credentialsId;
          this.getClientInfo();
        }).catch(error => {
          this.$message({
            showClose: true,
            type: "warning",
            message: "设置失败"
          });
        })
      },

      getClientInfo() {
        getAttributesClient(this.credentialsId).then(response => {
          if(response.client == undefined) {
            this.setClintInfo();
          } else if(response.client != undefined) {
            let flg = true;
            for (let obj in response.client){
              if(obj === 'cmd') {
                this.switchJson = JSON.parse(response.client[obj]);
                this.switchJson.op_fl = this.openFlg;
                this.switchJson.time = Math.floor(Date.now() / 1000);
                this.setClintInfo();
                flg = false;
                break;
              }
            }
            if(flg) {
              this.setClintInfo();
            }
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            type: "warning",
            message: "设置失败"
          });
        })
      },

      setClintInfo() {
        let cmdJson = {};
        cmdJson.cmd = JSON.stringify(this.switchJson);
        clientInfo(this.credentialsId, cmdJson).then(response => {
          this.$message({
            showClose: true,
            type: "warning",
            message: "设置成功"
          });
        }).catch(error => {
          this.$message({
            showClose: true,
            type: "warning",
            message: "设置失败"
          });
        })
      },

      defaultMask() {
        this.show = false;
      }
    }
  }
</script>

<style lang="less" scoped>
  // 渐变过渡
  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.35s;
  }

  .mask {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
  }

  .switch-pop {
    height: 100px;
    width: 15%;
    background: #4d99fc;
    border-radius: 8px;
    position: fixed;
    top: 40%;
    left: 13%;
    z-index: 9999;
    text-align: center;

    /*.form-el {*/
    /*  margin-top: 30px;*/
    /*  margin-right: 10px;*/
    /*  margin-left: 10px;*/
    /*  text-align: center;*/
    /*  color: #ffffff;*/
    /*}*/

    .switch-pop-title {
      width: 100%;
      height: 40%;
      text-align: center;
      font-size: 22px;
      padding-top: 3%;
      color: #ffffff;
    }

    .switch-pop-button {
      width: 100%;
      height: 60%;
    }

    .el-button {
      background-color: transparent;
      outline: none;
      font-size: 20px;
      appearance: none;
      -webkit-appearance: none;
      vertical-align: middle;
      text-align: center;
      margin-top: 5px;
      color: #08FEED;
      border-radius: 5px;
      border-style: ridge;
      border-color: transparent;
    }

    .el-form-item{
      margin-top: 10px;
      margin-bottom: 5px;
    }
    .el-form--inline .el-form-item {
      margin-left: 0px;
      margin-right: 10px;
    }
    .el-input {
      width: 60%;
      margin-left: -50px;
    }

    /deep/ .el-form-item__label {
      color: #ffffff;
      min-width: 145px;
      margin-left: 35px;
      text-align: center;
    }
  }
  .meun-switch {
    position: fixed;
    top: 69%;
    left: 20%;
    z-index: 2001;
    cursor: pointer;
    width: 20%;
    height: 10%;
    padding: 5px;
    transition: all 0.25s;

    &.leave {
      left: -65px;
    }
    &.active {
      left: 0;
    }
    &:hover {
      transform: scale(1.02);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/popup/switchSetDialog.vue